import React from 'react';
import { CustomImage } from 'components/shared/custom-image/CustomImage';
import {
  DirectionsLink,
  PERFORMANCE_LAB_PHONE_HREF,
} from 'components/performance-lab/performanceLabContactLinks';
import { PERFORMANCE_LAB_MAPS_URL } from 'components/performance-lab/performanceLabMaps';
import { useTranslations } from 'next-intl';
import { ArrowTopRight2 } from 'assets/icons/ArrowTopRight2';
import styles from './FooterSection.module.css';

const FooterSection: React.FC = () => {
  const t = useTranslations('performance-lab');
  return (
    <footer className={styles.footerWrapper}>
      <div className={styles.infoColumn}>
        <div className={styles.infoBlock}>
          <h3 className={styles.infoTitle}>{t('unifiedExperience.findUs')}</h3>
          <div className={styles.infoText}>
            <p>
              {t('unifiedExperience.venueName')}
            </p>
            <p>
              {t('unifiedExperience.addressLine1')}
            </p>
            <p>{t('unifiedExperience.addressLine2')}</p>
          </div>
          <DirectionsLink
            className={styles.footerDirectionsLink}
            href={PERFORMANCE_LAB_MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('getDirections.linkAria')}
            data-buttontype="performance_lab_get_directions"
          >
            {t('getDirections.linkText')}
            <ArrowTopRight2 fill="#000" aria-hidden />
          </DirectionsLink>
          <div className={styles.footerContactRow}>
            {t('getDirections.phoneLabel')}
            <DirectionsLink
              className={`${styles.footerDirectionsLink} ${styles.footerPhoneLink}`}
              href={PERFORMANCE_LAB_PHONE_HREF}
              aria-label={t('getDirections.phoneAria')}
              data-buttontype="performance_lab_call"
            >
              {t('getDirections.phoneText')}
            </DirectionsLink>
          </div>

          {/* <InfoText>{`performancelab@ultrahuman.com`}</InfoText> */}
        </div>
        <div className={styles.infoBlock}>
          <h3 className={styles.infoTitle}>
            {t('unifiedExperience.workingHours')}
          </h3>
          <div className={styles.infoText}>
            <p className={styles.hoursLabel}>
              {t('unifiedExperience.diagnosticsLabel')}
            </p>
            <p className={styles.hoursPrimary}>
              {t('unifiedExperience.diagnosticsDays')}
            </p>
            <p className={styles.hoursPrimary}>
              {t('unifiedExperience.diagnosticsHours')}
            </p>
            <p className={styles.hoursMuted}>
              {t('unifiedExperience.diagnosticsSunday')}
            </p>
            <p className={`${styles.hoursLabel} ${styles.hoursLabelSpaced}`}>
              {t('unifiedExperience.recoveryLabel')}
            </p>
            <p className={styles.hoursPrimary}>
              {t('unifiedExperience.recoveryDaysWeekday')}
            </p>
            <p className={styles.hoursPrimary}>
              {t('unifiedExperience.recoveryHoursWeekday')}
            </p>
            <p className={styles.hoursMuted}>
              {t('unifiedExperience.recoverySlotWeekday')}
            </p>
            <p className={styles.hoursPrimary}>
              {t('unifiedExperience.recoveryDaysSunday')}
            </p>
            <p className={styles.hoursPrimary}>
              {t('unifiedExperience.recoveryHoursSunday')}
            </p>
            <p className={styles.hoursMuted}>
              {t('unifiedExperience.recoverySlotSunday')}
            </p>
            <p className={`${styles.hoursMuted} ${styles.hoursNote}`}>
              {t('unifiedExperience.hoursNote')}
            </p>
          </div>
        </div>
      </div>
      <div className={styles.imageRow}>
        <div className={styles.imageContainer} data-shade="light">
          <CustomImage
            className={styles.footerImage}
            src="web_v2/performance-lab/pricing-page/placeholders/footer/footer-1.png"
            alt="Ultrahuman Performance Lab exterior"
            width={245}
            height={304}
          />
        </div>
        <div className={styles.imageContainer} data-shade="dark">
          <CustomImage
            className={styles.footerImage}
            src="web_v2/performance-lab/pricing-page/placeholders/footer/footer-2.png"
            alt="Cold plunge therapy"
            width={245}
            height={304}
          />
        </div>
        <div className={styles.imageContainer} data-shade="light">
          <CustomImage
            className={styles.footerImage}
            src="web_v2/performance-lab/pricing-page/placeholders/footer/footer-3.png"
            alt="Recovery session"
            width={245}
            height={304}
          />
        </div>
        <div className={styles.imageContainer} data-shade="dark">
          <CustomImage
            className={styles.footerImage}
            src="web_v2/performance-lab/pricing-page/placeholders/footer/footer-4.png"
            alt="VO2 max testing"
            width={245}
            height={304}
          />
        </div>
        <div className={styles.imageContainer} data-shade="light">
          <CustomImage
            className={styles.footerImage}
            src="web_v2/performance-lab/pricing-page/placeholders/footer/footer-5.png"
            alt="Treadmill assessment"
            width={245}
            height={304}
          />
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
